<template>
  <div class="grid-bd ub" :class="{border: border}">
    <slot></slot>
  </div>
</template>
<script>
/**
   * @param border [Boolean] 是否显示底部边框
   * @describe 九宫格组件
   *
   * @example
   *
    详见tGriditem组件
   */

export default {
  name: 'tGrid',
  props: {
    border: { type: Boolean }, // 是否显示边框
  },
};

</script>
<style scoped lang="scss">
@import '../style/mixin.scss';
.grid-bd.border {
  @include border-1px-b(#dedede);
}

</style>



// WEBPACK FOOTER //
// src/components/grid.vue